import React from "react";
import { Layout } from "antd";
import HorizontalDark from "../containers/Topbar/HorizontalDark";
import AccountMainNavBar from "components/Buyer/AccountMainNavBar/AccountMainNavBar";
import history from "../_helpers/history";
import Sidebar from "../containers/Sidebar";
import TopBar from "../components/TopBar/TopBar";
import SiteFooter from "../components/Buyer/FooterComponent/SiteFooter";

const { Content } = Layout;

const DefaultLayout = (ViewComponent) => {
  return class extends React.Component {
    componentDidMount() {
      // getter
      const user = localStorage.getItem("user");
      if (!user) {
        history.push(`login`);
      }
    }

    render() {
      return (
        <Layout className="gx-app-layout">
          <Sidebar />
          <Layout>
            <TopBar />
            <HorizontalDark />
            <AccountMainNavBar />
            <Content>
              <div className="gx-container">
                <ViewComponent />
              </div>
              <SiteFooter />
            </Content>
          </Layout>
        </Layout>
      );
    }
  };
};

export default DefaultLayout;
